import { get } from 'aws-amplify/api';

type GetOperation = ReturnType<typeof get>;

export function loadImports(): GetOperation {
  return get({
    apiName: 'Api',
    path: '/imports',
    options: { retryStrategy: { strategy: 'no-retry' } },
  });
}

export function refreshImport(importId: string): GetOperation {
  return get({
    apiName: 'Api',
    path: `/imports/${importId}`,
    options: { retryStrategy: { strategy: 'no-retry' } },
  });
}
